import { Component, Host, input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControl } from '@angular/forms';

@Component({
  template: 'FlmControlValueAccessor',
})
export abstract class Ad6ControlValueAccessorComponent<D> implements OnInit, ControlValueAccessor {
  formControlName = input.required<string>();

  formControl!: FormControl;

  value?: D;

  touched = false;

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer,
  ) {}

  ngOnInit(): void {
    if (this.controlContainer?.control) {
      this.formControl = this.controlContainer.control.get(this.formControlName()) as FormControl;
    } else {
      console.warn("Can't find parent FormGroup directive");
    }
  }

  onValueChanged(value: D): void {
    this.markAsTouched();
    this.onChange(value);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  onChange(value: D): void {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched(): void {}

  writeValue(value: D): void {
    this.value = value;
  }

  registerOnChange(onChange: never): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: never): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    if (this.formControl) {
      if (disabled) {
        this.formControl.disable();
      } else {
        this.formControl.enable();
      }
    }
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  compareByUuid(value: string, uuid?: string): boolean {
    return uuid !== undefined ? value === uuid : false;
  }
}
